// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9d15481d","453":"eb16c56f","732":"3d38dd50","762":"4c3d5b5e","857":"8b70de0f","977":"40ddb4be"}[chunkId] + ".chunk.js";
};